//src/app/(tabs)/_layout.jsx - Simplified pass-through layout
import { Outlet } from 'react-router-dom';

// This layout now serves as a simple pass-through since the main layout handles all navigation
export default function TabsLayout() {
  return <Outlet />;
}
